export default "__VITE_ASSET__7fbd7121__"